import { useNavigate } from 'react-router-dom';
import type { AttentionItem } from '../api/client';

interface NeedsAttentionProps {
  items: AttentionItem[];
}

export default function NeedsAttention({ items }: NeedsAttentionProps) {
  const navigate = useNavigate();

  if (items.length === 0) return null;

  return (
    <section className="px-[var(--sp-6)] py-[var(--sp-4)]">
      <h3
        className="text-[14px] font-semibold mb-[var(--sp-3)]"
        style={{ color: 'var(--color-text-neutral-strong)' }}
      >
        Needs attention
      </h3>
      <div className="flex flex-wrap gap-[var(--sp-2)]">
        {items.map((item) => {
          const isComment = item.type === 'comment';
          return (
            <button
              key={item.id}
              onClick={() => navigate(`/a/${item.artifact_id}`)}
              className="inline-flex items-center gap-[var(--sp-2)] px-[var(--sp-3)] h-[32px] rounded-[var(--radius-full)] text-[13px] font-medium transition-colors duration-[120ms] cursor-pointer border-0"
              style={{
                background: isComment
                  ? 'var(--color-surface-neutral-medium-default)'
                  : 'var(--color-surface-action-medium-default)',
                color: isComment
                  ? 'var(--color-text-neutral-medium)'
                  : 'var(--color-text-action-strong-default)',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background =
                  'var(--color-surface-neutral-medium-hover)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = isComment
                  ? 'var(--color-surface-neutral-medium-default)'
                  : 'var(--color-surface-action-medium-default)')
              }
            >
              <i
                className={`icon ${isComment ? 'icon-app-feedback' : 'icon-app-sync'}`}
                style={{ fontSize: 14 }}
              />
              <span className="truncate max-w-[200px]">{item.artifact_title}</span>
              <span
                className="inline-flex items-center justify-center min-w-[20px] h-[20px] rounded-full text-[13px] font-semibold"
                style={{
                  background: isComment
                    ? 'var(--color-border-neutral-subtle-default)'
                    : 'var(--color-border-action-subtle)',
                }}
              >
                {item.count}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
